<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 384 384"
    >
      <g>
        <g>
          <path
            :fill="iconColor"
            d="M275.3,140.7c-6.2-6.2-16.4-6.2-22.6,0L184,209.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6,0
              c-6.2,6.2-6.2,16.4,0,22.6l40,40c3.1,3.1,7.2,4.7,11.3,4.7s8.2-1.6,11.3-4.7l80-80C281.6,157.1,281.6,146.9,275.3,140.7z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="iconColor"
            d="M368,176c-8.8,0-16,7.2-16,16c0,88.2-71.8,160-160,160S32,280.2,32,192S103.8,32,192,32
              c43,0,83.3,16.8,113.5,47.3c6.2,6.3,16.4,6.3,22.6,0.1c6.3-6.2,6.3-16.4,0.1-22.6C291.9,20.1,243.5,0,192,0C86.1,0,0,86.1,0,192
              s86.1,192,192,192s192-86.1,192-192C384,183.2,376.8,176,368,176z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "CheckInIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
